module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-component"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.availableValues,
      "multiple": _vm.isMultiple,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name",
      "loading": _vm.loading
    },
    on: {
      "select": _vm.onSelect,
      "open": _vm.onOpen
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20d887b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/SelectColumnComponent.vue
// module id = 1247
// module chunks = 2